export const state = {
  azoliPiece: undefined,
  azoliPieces: [],
  communes: [],
  sousAzoliPiece: undefined,
  sousAzoliPieces: []
}